import exp from '@/api/report/expense'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  expenseItem(context, data) {
    return exp.expenseItem(data)
  },
  expenseItemExcel(context, data) {
    return exp.expenseItemExcel(data)
  },
  getExpenseItem(context) {
    return exp.getExpenseItem()
  }
}